import { render, staticRenderFns } from "./SubmissionCard.vue?vue&type=template&id=32dd1167&"
import script from "./SubmissionCard.vue?vue&type=script&lang=js&"
export * from "./SubmissionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports